import React from "react"
import H1Styled from "./H1Styled"

const H1 = ({ children }) => <H1Styled level={1}>{children}</H1Styled>

export default H1
